<template>
	<section class="usp-block" :class="color">
		<div class="row row-header">
			<div class="columns column12 align-center">
				<h2>
					{{ header }}
				</h2>
			</div>
		</div>
		<div class="row flex-row">
			<div
				v-for="(item, index) in items"
				:key="item.ID"
				class="columns column3 usp-item fade-animate fade-up"
				:class="'delay-' + index"
			>
				<picture>
					<source :srcset="item.imageWebp" type="image/webp" />
					<source :srcset="item.image" />
					<img :src="item.image" :alt="item.imageAlt" class="usp-item image" loading="lazy" />
				</picture>
				<span> {{ item.header }}</span>
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	header: { type: String, default: '' },
	items: { type: Array, default: () => [] },
	color: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.usp-block {
	background: var(--light-background-color);
	margin: 0;

	&.pink {
		background: var(--highlights-background-color);

		h2 {
			color: #fff;
		}
	}

	.flex-row {
		flex-flow: row nowrap;
	}
}

.usp-item {
	text-align: center;
	text-transform: uppercase;

	img {
		max-width: 230px;
		margin: 0 0 10px;
		aspect-ratio: 5 / 6;
	}

	span {
		display: inline-block;
		width: 100%;
		text-align: center;
		font-size: 18px;
		font-weight: 400;
	}
}

@media (max-width: 1080px) {
	.usp-block {
		.flex-row {
			flex-flow: row wrap;
		}
	}

	.usp-item {
		img {
			max-width: 200px;
		}

		span {
			font-size: 17px;
		}
	}
}

@media (max-width: 700px) {
	.usp-item {
		width: 50%;

		span {
			font-size: 16px;
		}
	}
}

@media (max-width: 580px) {
	.usp-item {
		width: 80%;
		margin: 0 auto;

		img {
			max-width: 160px;
		}
	}
}
</style>
